import {Modal, ModalBody, ModalHeader, ModalTitle, OverlayTrigger, Tooltip} from "react-bootstrap";
import React from "react";
import {useTranslation} from "react-i18next";
import FavoriteIcon from '@mui/icons-material/Favorite';
import * as UserService from "../api/UserService";
import Style from "./Style.module.css";



export default function AvailableFieldsPreviewSelector(props) {
    const {t, i18n} = useTranslation('translation', {keyPrefix: 'fieldStyleSelector'});

    function removeFavoriteField(field_id) {
        UserService.favoriteFields("remove", field_id, props.getAvailableFieldStyles, props.getAvailableFieldStyles)
    }

    function addFavoriteField(field_id) {
        UserService.favoriteFields("add", field_id, props.getAvailableFieldStyles, props.getAvailableFieldStyles)
    }

    return <Modal
        show={props.show}
        onHide={props.onClose}
        size="lg"
    >
        <ModalHeader closeButton>
            <ModalTitle>{t('selectFieldPreviewHeader')}</ModalTitle>

        </ModalHeader>
        <ModalBody>
            <div style={{fontSize: "20px", fontWeight: "bold"}}>{t('favorite')}</div>
            <div className={Style.favoriteFieldsPreview}>
                {props.availableStyles.filter((as) => as.favourite).map((as) => {
                    return <div
                        key={as.id}
                        style={{
                            backgroundImage: "url("+as.preview_img_url+")",
                            backgroundRepeat: "no-repeat",
                            width: "230px",
                            height: "120px",
                            backgroundSize: "100% 100%",
                            borderRadius: "6px",
                            border: as.id.toString() === props.selectedStyle.toString() ? "blue 4px solid" : "grey 1px solid",
                            cursor: as.id.toString() === props.selectedStyle.toString() ? "grabbing" : "pointer"
                        }}
                        onClick={() => {
                            if (as.id.toString() === props.selectedStyle.toString()) {
                                props.onClose()
                            } else {
                                props.setSelectedStyle({target: {value: as.id}})
                            }
                            props.setSelectedStyle({target: {value: as.id}})
                        }}
                        onDoubleClick={() => {
                            props.setSelectedStyle({target: {value: as.id}})
                            props.onClose()
                        }}
                    >
                        <OverlayTrigger
                            placement="top"
                            delay={{show: 400, hide: 50}}
                            overlay={<Tooltip
                                id="button-tooltip">{t('remove from favorites')}</Tooltip>}
                        >
                            <div style={{
                                width: "23px",
                                height: "23px",
                                border:"1px solid black",
                                borderRadius: "18px",
                                display:"flex",
                                alignItems:"center",
                                justifyContent: "center",
                                cursor:"pointer",
                                backgroundColor:"white",
                                margin: "3px"
                            }}
                                 onClick={(evt) => {
                                     removeFavoriteField(as.id)
                                     evt.stopPropagation()
                                 }}
                            >
                                <FavoriteIcon fontSize="small" sx={{color: "red"}}/>
                            </div>
                        </OverlayTrigger>
                    </div>
                })}
            </div>
            <div className={Style.otherFieldsPreview}>
                {props.availableStyles.filter((as) => !as.favourite).map((as) => {
                    return <div
                        key={as.id}
                        style={{
                            backgroundImage: "url("+as.preview_img_url+")",
                            backgroundRepeat: "no-repeat",
                            width: "230px",
                            height: "120px",
                            backgroundSize: "100% 100%",
                            borderRadius: "6px",
                            border: as.id.toString() === props.selectedStyle.toString() ? "blue 4px solid" : "grey 1px solid",
                            cursor: as.id.toString() === props.selectedStyle.toString() ? "grabbing" : "pointer"
                        }}
                        onClick={() => {
                            if (as.id.toString() === props.selectedStyle.toString()) {
                                props.onClose()
                            } else {
                                props.setSelectedStyle({target: {value: as.id}})
                            }
                            props.setSelectedStyle({target: {value: as.id}})
                        }}
                        onDoubleClick={() => {
                            props.setSelectedStyle({target: {value: as.id}})
                            props.onClose()
                        }}
                    >
                        <OverlayTrigger
                            placement="top"
                            delay={{show: 400, hide: 50}}
                            overlay={<Tooltip
                                id="button-tooltip">{t('add to favorites')}</Tooltip>}
                        >
                            <div style={{
                                width: "23px",
                                height: "23px",
                                border:"1px solid black",
                                borderRadius: "18px",
                                display:"flex",
                                alignItems:"center",
                                justifyContent: "center",
                                cursor:"pointer",
                                backgroundColor:"lightgray",
                                margin: "3px"
                            }}
                                 onClick={(evt) => {
                                     addFavoriteField(as.id)
                                     evt.stopPropagation()
                                 }}
                            >
                                <FavoriteIcon fontSize="small" color="action"/>
                            </div>
                        </OverlayTrigger>
                    </div>
                })}
            </div>
        </ModalBody>

    </Modal>
}